<template lang="pug">
.news-item.row.g-0
  .col-md-6
    a(:href='item.link')
      picture
        source(:srcset='item.images.thumb_news | webp')
        img(:src='item.images.thumb_news')
  .col-md-6.d-flex.flex-column
    .p-4
      h4 
        a.text-decoration-none.link-primary.fs-22.fw-bold(:href='item.link') {{ item.title }}
      p.news-excerpt.mb-0(v-html='item.excerpt')

    a.news-readmore.text-decoration-none.link-primary.fw-500.mt-auto.py-3.text-center(
      :href='item.link'
    ) อ่านเพิ่มเติม
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
}
</script>